import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/tongue-twister",
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

export const fetchAllTwisters = async (params) => {
  try {
    const res = await api.get("", { params });
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Failed to fetch",
    };
  }
};

export const fetchTwisterById = async (id) => {
  try {
    const res = await api.get(`${id}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Failed to fetch",
    };
  }
};

export const createTwister = async (data) => {
  try {
    const res = await api.post("", data);
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Create failed",
    };
  }
};

export const updateTwister = async (id, data) => {
  try {
    const res = await api.put(`${id}`, data);
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Update failed",
    };
  }
};

export const deleteTwister = async (id) => {
  try {
    const res = await api.delete(`${id}`);
    return { status: res.status };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Delete failed",
    };
  }
};
